import { CircularProgress } from "@mui/material";
import { css } from "@emotion/react";

export const LoadingIndicator = () => {
  return (
    <div css={loadingIndicatorStyles}>
      <CircularProgress size={10} />
    </div>
  );
};

const loadingIndicatorStyles = css({
  position: "absolute",
  top: 2,
  right: 2,
  display: "flex",
  height: "10px",
});
